var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V14.4656L18.3143 13.732C17.2086 12.549 15.3637 12.4569 14.1457 13.524L13.492 14.0967L12.0158 12.2798C10.8153 10.8022 8.55972 10.8022 7.35915 12.2798L5 15.1834V6ZM16.8532 15.0977L19 17.3946V18C19 18.5523 18.5523 19 18 19H17.476L14.754 15.65L15.4636 15.0283C15.8696 14.6726 16.4846 14.7033 16.8532 15.0977ZM5.04548 18.2991C5.17262 18.7053 5.55189 19 6 19H14.899L10.4636 13.541C10.0634 13.0485 9.31157 13.0485 8.91138 13.541L5.04548 18.2991ZM14 11C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7C12.8954 7 12 7.89543 12 9C12 10.1046 12.8954 11 14 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformPhotos);
export default __webpack_public_path__ + "static/media/platformPhotos.f6e38826.svg";
export { ForwardRef as ReactComponent };